import placeholder from '../assets/images/placeholder.jpeg';
import { BASE_URL } from '../configs/app-global';

export default function getImage(url) {
  if (!url) {
    return placeholder;
  }
  if (url.startsWith('https://example.org')) {
    return url.replace('https://example.org', BASE_URL);
  }
  if (url.startsWith('http://example.org')) {
    return url.replace('http://example.org', BASE_URL);
  }
  return url;
}
